import { turnActions } from '../../interfaceNew/actions'
import { getOptions } from '../../interfaceNew/selectors'

// Other plugins.
import { logManager } from '../../../logs'
import { CONNECT_FINISHED } from '../../../auth/interface/actionTypes'

// Libraries.
import { put, select } from 'redux-saga/effects'

const log = logManager.getLogger('CALL')

/**
 * Handles setting turn/stun information that has been
 *    received from the server.
 * @method setTurnCredentials
 * @param {Object} action A "connect finished" action.
 */
export function * setTurnCredentials (action) {
  const { serverTurnCredentials, defaultPeerConfig } = yield select(getOptions)

  // Must have ICE servers configured. Check the new way of configuring them...
  if (defaultPeerConfig.iceServers.length === 0) {
    log.debug('No ICE servers provided during setup; not using TURN/STUN for calls.')
    return
  }

  if (!serverTurnCredentials) {
    log.debug('Using application provided turn credentials.')
    return
  }

  // TURN credentials received from the server.
  const turnCredentials =
    action.type === CONNECT_FINISHED
      ? action.payload.subscription.turnCredentials
      : action.payload.subscriptions[0].turnCredentials

  const turnInfo = {
    credentials: turnCredentials,
    // Map the server-provided credentials to the ICE server list.
    servers: defaultPeerConfig.iceServers.map(iceInfo => {
      return {
        ...iceInfo,
        username: turnCredentials.username,
        credential: turnCredentials.password
      }
    })
  }

  yield put(turnActions.turnChanged(turnInfo))
}
